module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chap-title"
  }, [_c('a', {
    attrs: {
      "id": "pagexiii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/07_Contents#pro",
      "id": "pro"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('h1', {
    staticClass: "chap-author"
  }, [_c('em', [_vm._v("Leon Fleisher")])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("A man of infinite sweetness and gentleness. Eyes that danced with delight, aglitter with anticipation; speech that would occasionally hesitate as a flash of insight, a "), _c('em', [_vm._v("coup de foudre")]), _vm._v(" of inspiration would illumine his visage, a new awareness, a hitherto unseen relationship discovered.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1",
    staticStyle: {
      "padding-top": "0.5em"
    }
  }, [_vm._v("His willingness to introduce to a ten-year-old the mythology of a Mahler First Symphony (4 hands, 1 piano) left its indelible mark.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1",
    staticStyle: {
      "padding-top": "0.5em"
    }
  }, [_vm._v("His cherubic countenance, wreathed in a kind of perpetual epiphany, embodied the limitless joy and transformation that await us all if we but seek.")]), _vm._v(" "), _c('p', {
    staticClass: "pararight",
    staticStyle: {
      "margin-top": "1.5em"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/chap0_pagexiii_fig0.jpg"
    }
  }), _c('br'), _vm._v("Leon Fleisher")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b1a4b488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/08_Prologue.vue
// module id = 81
// module chunks = 0